(function () {
  'use strict';

  /* ═══════════════════════════════════════
     SVG Icons (Lucide-based, MIT)
     ═══════════════════════════════════════ */

  var I = {
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    back: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    warn: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',

    // Option icons
    chair: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 9V6a2 2 0 00-2-2H7a2 2 0 00-2 2v3"/><path d="M3 16a2 2 0 002 2h14a2 2 0 002-2v-5a2 2 0 00-4 0v2H7v-2a2 2 0 00-4 0z"/><path d="M5 18v2"/><path d="M19 18v2"/></svg>',
    desk: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="3" rx="1"/><path d="M6 10v9M18 10v9"/><path d="M12 5V2m-2 1.5L12 2l2 1.5"/></svg>',
    layers: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>',
    user: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    clock: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    activity: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>',
    zap: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    shield: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>',
    sun: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>',
    moon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>',
    leaf: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 019.8 6.9C15.5 4.9 17 3.5 17 3.5s1.5 2 3.5 7.7A7 7 0 0111 20z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
    star: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    expand: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>',
  };

  /* ═══════════════════════════════════════
     Quiz Static Maps (locale-independent)
     ═══════════════════════════════════════ */

  var NEXT_MAP = {
    'product-type': { chair: 'chair-height', desk: 'desk-space', both: 'chair-height' },
    'chair-height': 'chair-hours',
    'chair-hours': 'chair-pain',
    'chair-pain': null,
    'desk-space': 'workspace-style',
    'workspace-style': null,
  };

  var STYLE_MAP = {
    'light-minimal': { chair: 'grey',  deskTop: 'white',  deskLeg: 'white' },
    'dark-modern':   { chair: 'black', deskTop: 'walnut', deskLeg: 'black' },
    'warm-natural':  { chair: 'black', deskTop: 'oak',    deskLeg: 'black' },
    'classic':       { chair: 'black', deskTop: 'oak',    deskLeg: 'white' },
  };

  var PATHS = {
    chair: ['chair-height', 'chair-hours', 'chair-pain', 'workspace-style'],
    desk: ['desk-space', 'workspace-style'],
    both: ['chair-height', 'chair-hours', 'chair-pain', 'desk-space', 'workspace-style'],
  };

  // Variant matching — multi-language terms so the quiz finds the right SKU
  // regardless of how variants are named on the store (LT/PL/EN).
  var VARIANT_TERMS = {
    chair: {
      black: ['czarny', 'czarna', 'juoda', 'black'],
      grey:  ['szary', 'szara', 'pilka', 'grey', 'gray'],
    },
    deskSize: { '120': ['120'], '140': ['140'], '160': ['160'] },
    deskTop: {
      oak:    ['dąb', 'dab', 'ąžuolas', 'ąžuol', 'oak'],
      walnut: ['orzech', 'riešutas', 'riešut', 'walnut'],
      white:  ['biały', 'biala', 'balta', 'balt', 'white'],
    },
    deskLeg: {
      black: ['czarny', 'czarna', 'juoda', 'juodos', 'black'],
      white: ['biały', 'biala', 'balta', 'baltos', 'white'],
    },
  };

  /* ═══════════════════════════════════════
     Quiz Class
     ═══════════════════════════════════════ */

  function ErgonixQuiz(el) {
    this.el = el;
    this.answers = {};
    this.history = [];
    this.productData = {};
    this.t = {};
    this.locked = false;

    // Read translations injected by snippets/ergonix-quiz-i18n.liquid.
    // Fall back to document scope - the popup section renders the snippet
    // outside the .ergonix-quiz element (content is identical per page).
    var i18nEl = el.querySelector('[data-quiz-i18n]') || document.querySelector('[data-quiz-i18n]');
    if (i18nEl) { try { this.t = JSON.parse(i18nEl.textContent); } catch (e) { /* */ } }

    var dataEl = el.querySelector('[data-quiz-products]');
    if (dataEl) { try { this.productData = JSON.parse(dataEl.textContent); } catch (e) { /* */ } }

    // Product-type image icons from Shopify assets
    this.assetIcons = {
      chair: el.dataset.iconChair || '',
      desk: el.dataset.iconDesk || '',
      both: el.dataset.iconBoth || '',
    };

    this.questions = this.buildQuestions();

    el.addEventListener('click', this.handleClick.bind(this));
    this.showScreen('intro');
  }

  /* ── Build localized question definitions ── */

  ErgonixQuiz.prototype.buildQuestions = function () {
    var t = this.t;
    return {
      'product-type': {
        text: t.q_product_type,
        subtitle: t.q_product_type_sub,
        options: [
          { id: 'chair', label: t.opt_chair, desc: t.opt_chair_desc, icon: I.chair },
          { id: 'desk',  label: t.opt_desk,  desc: t.opt_desk_desc,  icon: I.desk },
          { id: 'both',  label: t.opt_both,  desc: t.opt_both_desc,  icon: I.layers },
        ],
      },
      'chair-height': {
        text: t.q_height,
        subtitle: t.q_height_sub,
        qIcon: I.user,
        options: [
          { id: 'under-155', label: t.opt_under_155 },
          { id: '155-175',   label: t.opt_155_175 },
          { id: '175-195',   label: t.opt_175_195 },
          { id: 'over-195',  label: t.opt_over_195 },
        ],
      },
      'chair-hours': {
        text: t.q_hours,
        subtitle: t.q_hours_sub,
        qIcon: I.clock,
        options: [
          { id: 'under-4', label: t.opt_under_4, desc: t.opt_under_4_desc },
          { id: '4-8',     label: t.opt_4_8,     desc: t.opt_4_8_desc },
          { id: 'over-8',  label: t.opt_over_8,  desc: t.opt_over_8_desc },
        ],
      },
      'chair-pain': {
        text: t.q_pain,
        subtitle: t.q_pain_sub,
        options: [
          { id: 'regular',    label: t.opt_regular,    icon: I.zap },
          { id: 'sometimes',  label: t.opt_sometimes,  icon: I.activity },
          { id: 'prevention', label: t.opt_prevention, icon: I.shield },
        ],
      },
      'desk-space': {
        text: t.q_desk_space,
        subtitle: t.q_desk_space_sub,
        qIcon: I.expand,
        options: [
          { id: '120', label: t.opt_compact,  desc: '120 × 60 cm' },
          { id: '140', label: t.opt_medium,   desc: '140 × 70 cm' },
          { id: '160', label: t.opt_spacious, desc: '160 × 80 cm' },
        ],
      },
      'workspace-style': {
        text: t.q_style,
        subtitle: t.q_style_sub,
        type: 'style',
        options: [
          { id: 'light-minimal', label: t.opt_light,   desc: t.opt_light_desc,   palette: ['#a0a0a0', '#f0ece4', '#f0ece4'] },
          { id: 'dark-modern',   label: t.opt_dark,    desc: t.opt_dark_desc,    palette: ['#2d2d2d', '#5c4033', '#2d2d2d'] },
          { id: 'warm-natural',  label: t.opt_warm,    desc: t.opt_warm_desc,    palette: ['#2d2d2d', '#c4a97d', '#2d2d2d'] },
          { id: 'classic',       label: t.opt_classic, desc: t.opt_classic_desc, palette: ['#2d2d2d', '#c4a97d', '#f0ece4'] },
        ],
      },
    };
  };

  ErgonixQuiz.prototype.handleClick = function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var a = btn.dataset.action;
    if (a === 'start') {
      this.track('quiz_start');
      this.showQuestion('product-type');
    }
    else if (a === 'select') {
      if (this.locked) return;
      this.selectAnswer(btn.dataset.question, btn.dataset.option);
    }
    else if (a === 'back') {
      if (this.locked) return;
      this.goBack();
    }
    else if (a === 'restart') this.restart();
  };

  ErgonixQuiz.prototype.showScreen = function (name) {
    this.el.querySelectorAll('.quiz-screen').forEach(function (s) { s.classList.remove('active'); });
    var s = this.el.querySelector('[data-screen="' + name + '"]');
    if (s) s.classList.add('active');
  };

  /* ── Render question ── */

  ErgonixQuiz.prototype.showQuestion = function (qid, isBack) {
    var q = this.questions[qid];
    if (!q) return;
    this.updateProgress(qid);

    var isStyle = q.type === 'style';
    var assetIcons = this.assetIcons;

    var optsHtml = q.options.map(function (opt) {
      var hasIcon = !!(opt.icon);
      var imgUrl = (qid === 'product-type') ? assetIcons[opt.id] : '';

      if (isStyle) {
        var dots = '';
        if (opt.palette) {
          dots = '<span class="quiz-palette">' + opt.palette.map(function (c) {
            return '<span class="quiz-palette__dot" style="background:' + c + '"></span>';
          }).join('') + '</span>';
        }
        return '<button class="quiz-option quiz-option--style" data-action="select" data-question="' + qid + '" data-option="' + opt.id + '">' +
          '<span class="quiz-option__text"><span class="quiz-option__label">' + opt.label + '</span>' +
          (opt.desc ? '<span class="quiz-option__description">' + opt.desc + '</span>' : '') +
          '</span>' + dots + '</button>';
      }

      if (imgUrl) {
        return '<button class="quiz-option quiz-option--image" data-action="select" data-question="' + qid + '" data-option="' + opt.id + '">' +
          '<span class="quiz-option__icon quiz-option__icon--image"><img src="' + imgUrl + '" alt="" width="72" height="100" loading="eager"></span>' +
          '<span class="quiz-option__text"><span class="quiz-option__label">' + opt.label + '</span>' +
          (opt.desc ? '<span class="quiz-option__description">' + opt.desc + '</span>' : '') +
          '</span></button>';
      }

      return '<button class="quiz-option" data-action="select" data-question="' + qid + '" data-option="' + opt.id + '">' +
        (hasIcon ? '<span class="quiz-option__icon">' + opt.icon + '</span>' : '') +
        '<span class="quiz-option__text"><span class="quiz-option__label">' + opt.label + '</span>' +
        (opt.desc ? '<span class="quiz-option__description">' + opt.desc + '</span>' : '') +
        '</span></button>';
    }).join('');

    var screen = this.el.querySelector('[data-screen="question"]');
    var content = screen.querySelector('.quiz-question__content');
    content.classList.remove('quiz-slide-forward', 'quiz-slide-back');
    void content.offsetHeight;

    content.innerHTML =
      (q.qIcon ? '<span class="quiz-question__icon">' + q.qIcon + '</span>' : '') +
      '<h3 class="quiz-question__title">' + q.text + '</h3>' +
      (q.subtitle ? '<p class="quiz-question__subtitle">' + q.subtitle + '</p>' : '') +
      '<div class="quiz-options">' + optsHtml + '</div>';

    content.classList.add(isBack ? 'quiz-slide-back' : 'quiz-slide-forward');

    var back = screen.querySelector('.quiz-back');
    if (back) back.style.display = this.history.length > 0 ? '' : 'none';

    this.showScreen('question');
  };

  /* ── Answer handling ── */

  ErgonixQuiz.prototype.selectAnswer = function (qid, oid) {
    this.locked = true;
    this.answers[qid] = oid;
    this.history.push(qid);
    this.track('quiz_answer', { question: qid, answer: oid });

    var sel = this.el.querySelector('[data-option="' + oid + '"][data-question="' + qid + '"]');
    if (sel) sel.classList.add('selected');

    var next = this.getNext(qid, oid);
    var self = this;
    setTimeout(function () {
      self.locked = false;
      if (next) {
        self.showQuestion(next);
      } else {
        self.showLoading();
      }
    }, 250);
  };

  ErgonixQuiz.prototype.getNext = function (qid, oid) {
    if (qid === 'chair-pain') return this.answers['product-type'] === 'both' ? 'desk-space' : 'workspace-style';
    var m = NEXT_MAP[qid];
    if (typeof m === 'string') return m;
    if (m && typeof m === 'object') return m[oid] || null;
    return null;
  };

  ErgonixQuiz.prototype.goBack = function () {
    if (!this.history.length) { this.showScreen('intro'); return; }
    var last = this.history.pop();
    delete this.answers[last];
    this.showQuestion(last, true);
  };

  ErgonixQuiz.prototype.restart = function () {
    this.answers = {};
    this.history = [];
    this.track('quiz_restart');
    this.showScreen('intro');
  };

  /* ── Progress ── */

  ErgonixQuiz.prototype.updateProgress = function (qid) {
    var fill = this.el.querySelector('.quiz-progress__fill');
    var text = this.el.querySelector('.quiz-progress__text');
    if (!fill) return;
    var row = this.el.querySelector('.quiz-progress');
    var type = this.answers['product-type'];
    var path = type ? (PATHS[type] || PATHS.chair) : null;
    var idx = path ? path.indexOf(qid) : -1;
    // Hide the row entirely on the router question (no path chosen yet) -
    // an empty grey bar reads as an unfinished element, not a progress bar.
    if (idx < 0) {
      if (row) row.style.display = 'none';
      fill.style.width = '0';
      if (text) text.textContent = '';
      return;
    }
    if (row) row.style.display = '';
    fill.style.width = ((idx + 1) / path.length * 100) + '%';
    if (text) text.textContent = (idx + 1) + ' / ' + path.length;
  };

  /* ── Loading state ── */

  ErgonixQuiz.prototype.showLoading = function () {
    this.locked = true;
    var rs = this.el.querySelector('[data-screen="result"]');
    rs.innerHTML =
      '<div class="quiz-loading">' +
        '<div class="quiz-loading__spinner"></div>' +
        '<p class="quiz-loading__text">' + (this.t.loading_text || '') + '</p>' +
      '</div>';
    this.showScreen('result');
    var self = this;
    setTimeout(function () {
      self.locked = false;
      self.showResult();
    }, 1400);
  };

  /* ═══════════════════════════════════════
     Results
     ═══════════════════════════════════════ */

  ErgonixQuiz.prototype.showResult = function () {
    var type = this.answers['product-type'];
    var t = this.t;
    var h = '<div class="quiz-result__content">';

    if (type === 'chair') {
      h += this.resultHeader(this.matchScore(), t.result_chair);
    } else if (type === 'desk') {
      h += this.resultHeader(null, t.result_desk);
    } else {
      h += this.resultHeader(this.matchScore(), t.result_bundle);
    }

    if (type === 'chair' || type === 'both') {
      var hw = this.heightWarn();
      if (hw) h += '<div class="quiz-height-warning">' + I.warn + '<span>' + hw + '</span></div>';
    }

    if (type === 'chair' || type === 'both') h += this.chairCard();
    if (type === 'both') h += '<div class="quiz-result__divider"></div>';
    if (type === 'desk' || type === 'both') h += this.deskCard();
    if (type === 'chair') h += this.upsellWrap(this.upsellItem(this.productData.wheels));
    else if (type === 'desk') h += this.upsellWrap(this.upsellItem(this.productData.drawer));
    else h += this.upsellWrap(this.upsellItem(this.productData.wheels) + this.upsellItem(this.productData.drawer));

    h += '<button class="quiz-restart" data-action="restart">' + (t.restart || '') + '</button>';
    h += '</div>';

    var rs = this.el.querySelector('[data-screen="result"]');
    if (rs) rs.innerHTML = h;
    this.showScreen('result');
    this.track('quiz_complete', { path: type });

    var self = this;
    setTimeout(function () {
      var hdrH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var top = self.el.getBoundingClientRect().top + window.scrollY - hdrH - 20;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 50);
  };

  ErgonixQuiz.prototype.resultHeader = function (score, title) {
    var t = this.t;
    var badge = score ? (' ' + score + '% ' + (t.match_pct || '')) : (' ' + (t.picked_for_you || ''));
    return '<div class="quiz-result__header">' +
      '<span class="quiz-result__badge">' + I.check + badge + '</span>' +
      '<h3 class="quiz-result__title">' + title + '</h3>' +
      '<p class="quiz-result__subtitle">' + (t.result_subtitle || '') + '</p>' +
      '</div>';
  };

  /* Price of the MATCHED variant when one was found - the product-level
     price is the cheapest variant and contradicts the shown configuration. */
  /* One money format for the whole theme. The price_formatted strings in the quiz JSON come
     from Shopify's shop-wide money_format ("€279,00"), which is symbol-first on every EUR
     market and dot-grouped on PLN, while everything else on the page is painted by
     window.formatMoney (cart.js, Intl) as "279,00 €" / "1059,00 zł". Prefer the canonical
     formatter and keep the string as the fallback for a page where cart.js has not loaded.
     The JSON keeps both, so an older copy of this file still renders. */
  ErgonixQuiz.prototype.money = function (cents, fallback) {
    if (typeof cents === 'number' && cents > 0 && typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }
    return fallback || '';
  };

  ErgonixQuiz.prototype.priceBits = function (d, v) {
    if (v && v.price_formatted) {
      return {
        price: this.money(v.price, v.price_formatted),
        cmp: this.money(v.compare_at_price, v.compare_price_formatted || ''),
        disc: this.discount(v.price, v.compare_at_price),
      };
    }
    return {
      price: this.money(d.price_raw, d.price_formatted || ''),
      cmp: this.money(d.compare_price_raw, d.compare_price_formatted || ''),
      disc: this.discount(d.price_raw, d.compare_price_raw),
    };
  };

  ErgonixQuiz.prototype.chairCard = function () {
    var d = this.productData.chair || {};
    var v = this.findChairVariant(d);
    var feats = this.chairFeatures();
    var img = (v && v.image) || d.image || '';
    var vTitle = (v && v.title) || '';
    var url = (v && v.url) || d.url || '#';
    var pb = this.priceBits(d, v);
    var price = pb.price;
    var cmp = pb.cmp;
    var disc = pb.disc;
    var name = d.title || 'OmniSit Pro';

    return '<div class="quiz-product-card">' +
      (img ? '<div class="quiz-product-card__image-wrap"><img class="quiz-product-card__image" src="' + this.escAttr(img) + '" alt="' + this.esc(name) + '" loading="lazy"></div>' : '') +
      '<div class="quiz-product-card__body">' +
      '<h4 class="quiz-product-card__name">' + this.esc(name) + (vTitle ? ' - ' + this.esc(vTitle) : '') + '</h4>' +
      '<div class="quiz-product-card__price">' +
      (price ? '<span class="quiz-product-card__current">' + price + '</span>' : '') +
      (cmp ? '<span class="quiz-product-card__compare">' + cmp + '</span>' : '') +
      (disc > 0 ? '<span class="quiz-product-card__discount">-' + disc + '%</span>' : '') +
      '</div>' +
      '<ul class="quiz-features">' + feats.map(function (f) { return '<li>' + f + '</li>'; }).join('') + '</ul>' +
      '<a href="' + this.escAttr(url) + '" class="quiz-btn quiz-btn--cta quiz-btn--full">' + (this.t.view_chair || '') + ' ' + I.arrow + '</a>' +
      '</div></div>';
  };

  ErgonixQuiz.prototype.deskCard = function () {
    var t = this.t;
    var d = this.productData.desk || {};
    var v = this.findDeskVariant(d);
    var img = (v && v.image) || d.image || '';
    var url = (v && v.url) || d.url || '#';
    var pb = this.priceBits(d, v);
    var price = pb.price;
    var cmp = pb.cmp;
    var disc = pb.disc;
    var name = d.title || 'OmniPRO';

    var sL = { '120': '120×60 cm', '140': '140×70 cm', '160': '160×80 cm' };
    var tL = { oak: t.top_oak, walnut: t.top_walnut, white: t.top_white };
    var lL = { black: t.legs_black, white: t.legs_white };
    var style = STYLE_MAP[this.answers['workspace-style']] || {};
    var topKey = this.variantTermKey(v, 'deskTop') || style.deskTop;
    var legKey = this.variantTermKey(v, 'deskLeg') || style.deskLeg;
    var cfg = [sL[this.answers['desk-space']], tL[topKey], lL[legKey]].filter(Boolean).join(', ');

    var feats = this.deskFeatures();
    var ctaLabel = t.view_desk || '';

    return '<div class="quiz-product-card">' +
      (img ? '<div class="quiz-product-card__image-wrap"><img class="quiz-product-card__image" src="' + this.escAttr(img) + '" alt="' + this.esc(name) + '" loading="lazy"></div>' : '') +
      '<div class="quiz-product-card__body">' +
      '<h4 class="quiz-product-card__name">' + this.esc(name) + '</h4>' +
      (cfg ? '<p class="quiz-product-card__config">' + cfg + '</p>' : '') +
      '<div class="quiz-product-card__price">' +
      (price ? '<span class="quiz-product-card__current">' + price + '</span>' : '') +
      (cmp ? '<span class="quiz-product-card__compare">' + cmp + '</span>' : '') +
      (disc > 0 ? '<span class="quiz-product-card__discount">-' + disc + '%</span>' : '') +
      '</div>' +
      '<ul class="quiz-features">' + feats.map(function (f) { return '<li>' + f + '</li>'; }).join('') + '</ul>' +
      '<a href="' + this.escAttr(url) + '" class="quiz-btn quiz-btn--cta quiz-btn--full">' + ctaLabel + ' ' + I.arrow + '</a>' +
      '</div></div>';
  };

  ErgonixQuiz.prototype.upsellItem = function (p) {
    // Skip sold-out accessories (available=false in the data-quiz-products
    // JSON) so the quiz never recommends something that cannot be bought.
    if (!p || !p.title || p.available === false) return '';
    return '<div class="quiz-upsell__item">' +
      (p.image ? '<img class="quiz-upsell__image" src="' + this.escAttr(p.image) + '" alt="' + this.esc(p.title) + '" loading="lazy">' : '') +
      '<div class="quiz-upsell__info"><span class="quiz-upsell__name">' + this.esc(p.title) + '</span>' +
      (p.price_formatted ? '<span class="quiz-upsell__price">' + this.money(p.price_raw, p.price_formatted) + '</span>' : '') +
      '</div><a href="' + this.escAttr(p.url || '#') + '" class="quiz-btn quiz-btn--secondary quiz-btn--sm">' + (this.t.view_item || '') + '</a></div>';
  };

  ErgonixQuiz.prototype.upsellWrap = function (items) {
    if (!items) return '';
    return '<div class="quiz-upsell"><h5 class="quiz-upsell__title">' + (this.t.upsell_title || '') + '</h5>' + items + '</div>';
  };

  /* ── Personalized features ── */

  ErgonixQuiz.prototype.chairFeatures = function () {
    var t = this.t;
    var f = [];
    var h = this.answers['chair-height'];
    var hrs = this.answers['chair-hours'];
    var pain = this.answers['chair-pain'];

    if (h === '155-175' || h === '175-195') {
      var range = (h === '155-175') ? '150-175' : '175-205';
      f.push((t.chair_feat_height_ok || '').replace('{{range}}', range).replace('{{ range }}', range));
    }
    else if (h === 'under-155') f.push(t.chair_feat_height_low);
    else f.push(t.chair_feat_height_high);

    if (hrs === 'over-8') f.push(t.chair_feat_hours_high);
    else if (hrs === '4-8') f.push(t.chair_feat_hours_mid);
    else f.push(t.chair_feat_hours_low);

    if (pain === 'regular') { f.push(t.chair_feat_pain_regular); f.push(t.chair_feat_pain_regular2); }
    else if (pain === 'sometimes') f.push(t.chair_feat_pain_sometimes);
    else f.push(t.chair_feat_pain_prevent);

    var sLabels = {
      'light-minimal': t.chair_feat_style_light,
      'dark-modern':   t.chair_feat_style_dark,
      'warm-natural':  t.chair_feat_style_warm,
      'classic':       t.chair_feat_style_classic,
    };
    var ws = this.answers['workspace-style'];
    if (ws && sLabels[ws]) f.push(sLabels[ws]);

    f.push(t.chair_feat_certified);
    f.push(t.chair_feat_warranty);
    return f.filter(Boolean);
  };

  ErgonixQuiz.prototype.deskFeatures = function () {
    var t = this.t;
    var f = [];
    var size = this.answers['desk-space'];
    var ws = this.answers['workspace-style'];

    if (size === '160') f.push(t.desk_feat_160);
    else if (size === '140') f.push(t.desk_feat_140);
    else if (size === '120') f.push(t.desk_feat_120);
    else f.push(t.desk_feat_electric);

    f.push(t.desk_feat_motor);

    var sLabels = {
      'light-minimal': t.desk_feat_style_light,
      'dark-modern':   t.desk_feat_style_dark,
      'warm-natural':  t.desk_feat_style_warm,
      'classic':       t.desk_feat_style_classic,
    };
    if (ws && sLabels[ws]) f.push(sLabels[ws]);

    f.push(t.desk_feat_abs);
    f.push(t.desk_feat_warranty);
    return f.filter(Boolean);
  };

  ErgonixQuiz.prototype.matchScore = function () {
    var s = 72;
    var h = this.answers['chair-height'], hrs = this.answers['chair-hours'], p = this.answers['chair-pain'];
    if (h === '155-175' || h === '175-195') s += 8; else s += 2;
    if (hrs === 'over-8') s += 7; else if (hrs === '4-8') s += 5; else s += 3;
    if (p === 'regular') s += 8; else if (p === 'sometimes') s += 5; else s += 3;
    return Math.min(s, 97);
  };

  ErgonixQuiz.prototype.heightWarn = function () {
    var h = this.answers['chair-height'];
    if (h === 'under-155') return this.t.warn_too_short || null;
    if (h === 'over-195') return this.t.warn_too_tall || null;
    return null;
  };

  /* ── Variant matching ── */

  ErgonixQuiz.prototype.findChairVariant = function (d) {
    if (!d || !d.variants) return null;
    var style = STYLE_MAP[this.answers['workspace-style']];
    if (!style) return null;
    var terms = VARIANT_TERMS.chair[style.chair];
    if (!terms) return null;
    return d.variants.find(function (v) {
      var opts = (v.options || []).map(function (o) { return o.toLowerCase(); });
      return opts.some(function (o) { return terms.some(function (t) { return o.indexOf(t) >= 0; }); });
    }) || null;
  };

  ErgonixQuiz.prototype.findDeskVariant = function (d) {
    if (!d || !d.variants) return null;
    var style = STYLE_MAP[this.answers['workspace-style']];
    if (!style) return null;
    var sT = VARIANT_TERMS.deskSize[this.answers['desk-space']] || [];
    var tT = VARIANT_TERMS.deskTop[style.deskTop] || [];
    var lT = VARIANT_TERMS.deskLeg[style.deskLeg] || [];
    var matches = function (v, groups) {
      var j = (v.options || []).map(function (o) { return o.toLowerCase(); }).join(' ');
      return groups.every(function (g) {
        return g.some(function (t) { return j.indexOf(t) >= 0; });
      });
    };
    var inStock = d.variants.filter(function (v) { return v.available !== false; });
    // Exact style match among in-stock variants first. If the style's leg colour is
    // sold out store-wide (e.g. white frame since 2026-07), keep size+top and take an
    // in-stock leg colour instead of recommending an unbuyable variant. Last resort:
    // the exact match even if sold out (the PDP then shows its out-of-stock card).
    return inStock.find(function (v) { return matches(v, [sT, tT, lT]); })
        || inStock.find(function (v) { return matches(v, [sT, tT]); })
        || d.variants.find(function (v) { return matches(v, [sT, tT, lT]); })
        || null;
  };

  // Which VARIANT_TERMS[group] key the variant actually carries. The result card
  // label must reflect the RECOMMENDED variant, not the style's wish - they differ
  // when findDeskVariant's fallback swapped a sold-out leg colour.
  ErgonixQuiz.prototype.variantTermKey = function (v, group) {
    if (!v) return null;
    var j = (v.options || []).map(function (o) { return o.toLowerCase(); }).join(' ');
    var terms = VARIANT_TERMS[group] || {};
    for (var key in terms) {
      if (terms.hasOwnProperty(key) && terms[key].some(function (t) { return j.indexOf(t) >= 0; })) return key;
    }
    return null;
  };

  /* ── Utilities ── */

  ErgonixQuiz.prototype.discount = function (p, c) {
    if (!c || !p || c <= p) return 0;
    return Math.round((1 - p / c) * 100);
  };

  ErgonixQuiz.prototype.esc = function (s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  };

  ErgonixQuiz.prototype.escAttr = function (s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  ErgonixQuiz.prototype.track = function (event, data) {
    if (typeof window.dataLayer !== 'undefined') {
      var payload = { event: event };
      if (data) { for (var k in data) { if (data.hasOwnProperty(k)) payload[k] = data[k]; } }
      window.dataLayer.push(payload);
    }
  };

  /* ═══════════════════════════════════════
     Init
     ═══════════════════════════════════════ */

  function init() {
    document.querySelectorAll('.ergonix-quiz:not(.quiz--ok)').forEach(function (el) {
      new ErgonixQuiz(el);
      el.classList.add('quiz--ok');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
